import React, { useState, useEffect } from 'react';

// Utils
import { formatCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getRowStyle, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const DeposModal = ({ showDeposModal, handleDeposClose, deposDataList, onRowSelectDepos }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredDeposDataList, setFilteredDeposDataList] = useState(deposDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0); // เพิ่ม state สำหรับเลือกแถว

    useEscapeClose(showDeposModal, handleDeposClose);
    
    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showDeposModal,
        filteredDeposDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectDepos,
        handleDeposClose
    );
    
    // ฟิลเตอร์ข้อมูลเมื่อ searchTerm หรือ deposDataList เปลี่ยนแปลง
    useEffect(() => {
        setFilteredDeposDataList(
            deposDataList.filter(depos =>
                depos.Doc_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
                depos.AR_Name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อข้อมูลเปลี่ยน
    }, [searchTerm, deposDataList]);

    useEffect(() => {
        if (showDeposModal) {
            setSearchTerm('');
            setSelectedRowIndex(0); // รีเซ็ตการเลือกแถวเมื่อเปิด modal
        }
    }, [showDeposModal]);

    return (
        <>
            {/* Modal */}
            <div className={`modal ${showDeposModal ? 'show' : ''}`} style={{ display: showDeposModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อใบมัดจำ</h5>
                            <button type="button" className="close" onClick={handleDeposClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหาเลขที่เอกสาร (DEPOS) หรือ ชื่อลูกค้า"
                                    value={searchTerm || ''}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '15%' }}>เลขที่เอกสาร (DEPOS)</th>
                                            <th className="text-center" style={{ width: '40%' }}>ชื่อลูกค้า</th>
                                            <th className="text-center" style={{ width: '35%' }}>รายละเอียดเอกสาร</th>
                                            <th className="text-center" style={{ width: '10%' }}>ราคารวม</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredDeposDataList && filteredDeposDataList.length > 0 ? (
                                            filteredDeposDataList.map((depos, index) => (
                                                <tr
                                                    key={depos.Doc_Id || index + 1}
                                                    onClick={() => {
                                                        setSelectedRowIndex(index); // อัปเดต selectedRowIndex เมื่อคลิก
                                                        onRowSelectDepos(depos);
                                                    }}
                                                    style={getRowStyle(index, selectedRowIndex)}>
                                                    <td className="text-center">{depos.Doc_No}</td>
                                                    <td className="text-left">{depos.AR_Name}</td>
                                                    <td className="text-left">{depos.Doc_Remark1}</td>
                                                    <td className="text-end">{formatCurrency(depos.NetTotal)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                                {getKeyboardInstructions('มัดจำ')}
                            </div>
                            <button className="btn btn-secondary" onClick={handleDeposClose}>
                                ปิด (ESC)
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Overlay */}
            {showDeposModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default DeposModal;